import { FileShareReportProfilePermissions } from '../../../microsoft/fileshare/profile/file-share-report-profile-permissions';
import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';

export class FileShareReportProfileAlertPermissionsModel extends ReportProfileAlertResourceBaseModel {
  permissions: FileShareReportProfilePermissions;
  allPaths: boolean;
  invalidPaths: string[];
}
